import {
  DEFAULT_TENANT_TYPE_TAB,
  TENANT_TYPES,
  tenantTypeToTabValue
} from '@lib/tenantTypes'
import { NavLink, Stack, Text } from '@mantine/core'

type IcpTypeSidebarProps = {
  activeTypeKeys: string[]
  selectedTabValue: string
  onSelect: (tabValue: string) => void
}

export function IcpTypeSidebar({
  activeTypeKeys,
  selectedTabValue,
  onSelect
}: IcpTypeSidebarProps) {
  return (
    <Stack gap={4}>
      <Text size="xs" tt="uppercase" fw={600} c="dimmed" mb="xs">
        Tenant type (ICP)
      </Text>
      {activeTypeKeys.map((tenantType) => {
        const meta = TENANT_TYPES.find((t) => t.value === tenantType)
        const tabValue = tenantTypeToTabValue(tenantType)
        const isActive = selectedTabValue === tabValue

        return (
          <NavLink
            key={tabValue}
            label={meta?.label ?? (tenantType || 'Default')}
            description={meta?.description}
            active={isActive}
            onClick={() => onSelect(tabValue)}
            variant="light"
          />
        )
      })}
      {!activeTypeKeys.length && (
        <Text size="sm" c="dimmed">
          No tenant types loaded.
        </Text>
      )}
    </Stack>
  )
}

export { DEFAULT_TENANT_TYPE_TAB, tenantTypeToTabValue }
